(function (window) {
  var createModeToggle = function (options) {
    var $header = $("<div />", {
      class: "batchgeo-ui-map-mode-toggle-header",
      html: [
        $("<input />", {
          type: "radio",
          name: "map_mode",
          value: options.value,
          checked: options["default"],
        }),
        $("<p />", { text: options.title }),
      ],
    });

    var $icon = $("<span />", {
      class: "batchgeo-ui-map-mode-toggle-image-wrap",
      html: $("<img />", { src: options.iconSrc }),
    });

    var $description = $("<p />", {
      class: "small",
      text: options.description,
    });

    return $("<label />", {
      class: "batchgeo-ui-map-mode-toggle-label",
      html: [$header, $icon, $description],
    });
  };

  BatchGeoUi.MapModeToggle = function () {
    const strings = window.BatchGeoStrings.getStringsForComponent(
      "BatchGeoSaveMapMode",
    );
    var baseIconSrc = "/images/BatchGeoUiMapModeToggle";
    return $("<div />", {
      class: "batchgeo-ui-map-mode-toggle",
      html: [
        createModeToggle({
          value: "data_view",
          title: strings.get("DATA_VIEW_TITLE"),
          iconSrc: baseIconSrc + "/data-view.svg",
          description: strings.get("DATA_VIEW_DESC"),
          default: true,
        }),
        createModeToggle({
          value: "store_locator",
          title: strings.get("STORE_LOCATOR_TITLE"),
          iconSrc: baseIconSrc + "/store-locator.svg",
          description: strings.get("STORE_LOCATOR_DESC"),
        }),
      ],
    });
  };
})(window);
